import React from 'react';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y } from 'swiper/modules';

const WhiteBoxSlider = ({ data }) => {
  const {
    title,
    showTitle,
    images
  } = data;
  return (
    <Section spacing='mb-4'>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <Row>
          {images &&
            <Swiper
              pagination={{
                el: '.swiper-pagination-custom',
                type: 'bullets',
                clickable: true
              }}
              modules={[Pagination, A11y]}
              slidesPerView={1.5}
              spaceBetween={20}
              breakpoints={{
              992: {
                slidesPerView: 4,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 20
              },
              385: {
                slidesPerView: 1.75,
                spaceBetween: 20
              }
              }}>
              {images.map((image, index) => (
                <SwiperSlide key={index} className='p-3 border border-3 border-dark-grey-4 bg-white rounded'>
                  <div className='d-flex flex-column'>
                    <Img image={image.gatsbyImageData} file={image.file} className='align-self-center mb-2'/>
                    {image.title && <div className='fs-18 fw-medium mb-1'>{image.title}</div>}
                    {image.description && <div className='fs-14'>{image.description}</div>}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          }
        </Row>
        <div className='swiper-pagination-custom d-flex justify-content-center mt-3'/>
      </Container>
    </Section>
  )
}

export default WhiteBoxSlider
